function nunjucks_global_dateTypes(catalog_utils)
{
    this.name = 'dateTypes';
    this.value = catalog_utils.dateTypes;
}